/* unplugin-vue-components disabled */import script from "./ResetPassword.vue?vue&type=script&setup=true&lang=js"
export * from "./ResetPassword.vue?vue&type=script&setup=true&lang=js"

import "./ResetPassword.vue?vue&type=style&index=0&id=592acc7b&lang=less"

const __exports__ = script;

export default __exports__